import React from 'react';
import { styles } from './AskForADeal.css';
import Button from '@jbhi-fi/lanyard-ui/components/Button';
import PhoneIcon from '@jbhi-fi/lanyard-ui/components/Icons/Phone';
import Chat from '@jbhi-fi/lanyard-ui/components/Icons/Chat';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';
import { useSupport } from '../../context/SupportProvider';

export type AskForADealProps = {
  className?: string;
  message: string;
  isEnabled?: boolean;
  isVertical?: boolean;
};

export const AskForADeal: React.FC<AskForADealProps> = ({ className, message, isEnabled, isVertical }) => {
  const { phoneNumber, onCallClick, onChatClick } = useSupport();

  return isEnabled ? (
    <div id="seenitcheaper-cta" className={classNames([styles.askForADeal({ isVertical }), className])}>
      <div>
        <div className={styles.hookLine} dangerouslySetInnerHTML={{ __html: message }}></div>
      </div>
      <div className={styles.contactUsContainer({ isVertical })}>
        <div className={styles.buttonContainer}>
          <Button type="linkWithIcon" label="Chat with us" onClick={onChatClick} icon={<Chat />} iconPosition="left" />
        </div>
        <div className={styles.buttonContainer}>
          <Button
            type="linkWithIcon"
            onClick={onCallClick}
            label={`Call ${phoneNumber}`}
            icon={<PhoneIcon className={styles.phoneIcon} />}
            iconPosition="left"
          />
        </div>
      </div>
    </div>
  ) : null;
};
